import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../image/health-guide-logo.png';
import '../Page/LegalCard.css';

const CONTACT_EMAIL = 'healthguide@chantharzay.com';
const CONTACT_PHONE = '09-699101168';

const MAIL_SUBJECT = 'Delete my Health Guide account';
const MAIL_BODY = [
  'Please delete my Health Guide MM account and all of its data.',
  '',
  'Registered phone number: ',
  'Username: ',
].join('\n');

const mailtoHref = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(MAIL_SUBJECT)}&body=${encodeURIComponent(MAIL_BODY)}`;

const DeleteAccount = () => {
  return (
    <div className="hg-legal">
      <main className="hg-wrapper">
        <section className="hg-card">
          <header className="hg-header">
            <img src={logo} alt="Health Guide MM Logo" className="hg-logo" />
            <h1>Delete Your Account</h1>
            <div className="hg-updated">Health Guide MM (ကျန်းမာလမ်းညွှန်) by Chantharzay</div>
          </header>

          <p>
            You can ask us to delete your <strong>Health Guide MM</strong> account and the data linked
            to it at any time. This page explains how to make the request and what will be deleted.
          </p>

          <h2>How to request deletion</h2>
          <ol>
            <li>
              Send an email to <a href={mailtoHref}>{CONTACT_EMAIL}</a> with the subject
              "<strong>{MAIL_SUBJECT}</strong>".
            </li>
            <li>
              Include the <strong>phone number</strong> and <strong>username</strong> you registered
              with, so we can find your account.
            </li>
            <li>
              We may contact you on that phone number to confirm that the request came from you.
            </li>
            <li>
              We delete your account within <strong>7 days</strong> and let you know when it is done.
            </li>
          </ol>

          <p>
            <a className="hg-button" href={mailtoHref}>Email a deletion request</a>
            <a className="hg-button hg-button-outline" href={`tel:${CONTACT_PHONE.replace(/-/g, '')}`}>
              Call {CONTACT_PHONE}
            </a>
          </p>

          <p>
            If you cannot send an email, you can also call or message us on Viber at{' '}
            <strong>{CONTACT_PHONE}</strong>.
          </p>

          <h2>What we delete</h2>
          <ul>
            <li>Your account: phone number, username, password, city and region.</li>
            <li>Your AI health guide questions and symptom answers.</li>
            <li>Your booking history, including patient names and ages you entered.</li>
            <li>Your quiz answers, points, rewards and notification history.</li>
            <li>Your push notification token.</li>
          </ul>

          <div className="hg-callout hg-warning">
            <strong>Deletion is permanent.</strong> After your account is deleted you cannot log in
            again with it, and your points and rewards cannot be restored. You are welcome to create a
            new account later.
          </div>

          <h2>What may be kept</h2>
          <ul>
            <li>
              <strong>Bookings already sent to a clinic</strong> – the clinic may keep its own copy of
              your booking request under its own records policy.
            </li>
            <li>
              <strong>Ad measurement events</strong> – app events already sent to Meta do not contain
              your name, phone number or health information, and are handled under{' '}
              <a href="https://www.facebook.com/privacy/policy" target="_blank" rel="noopener noreferrer">Meta's Privacy Policy</a>.
            </li>
          </ul>

          <h2>More information</h2>
          <p>
            Read our <Link to="/privacy-policy">Privacy Policy</Link> to learn what information Health
            Guide MM collects and how it is used.
          </p>

          <footer className="hg-footer">© 2026 Health Guide MM by Chantharzay. All rights reserved.</footer>
        </section>
      </main>
    </div>
  );
};

export default DeleteAccount;
